// src/pages/VehicleLocationsPieChart.jsx
import React from "react";
import { ResponsivePie } from "@nivo/pie";

const VehicleLocationsPieChart = ({
  dayData = [],
  nightData = [],
  groupLevel,
  onItemSelect,
  colors,
}) => {
  // Combinar datos de día y noche
  const dict = {};
  dayData.forEach((item) => {
    const key = item.level || "SIN_DIA";
    if (!dict[key]) dict[key] = 0;
    dict[key] += Number(item.total_vehiculos || 0);
  });
  nightData.forEach((item) => {
    const key = item.level || "SIN_NOCHE";
    if (!dict[key]) dict[key] = 0;
    dict[key] += Number(item.total_vehiculos || 0);
  });

  // Convertir a array y ordenar
  const combinedArray = Object.keys(dict)
    .map((key) => ({
      id: key,
      label: key,
      value: dict[key],
    }))
    .sort((a, b) => b.value - a.value);

  // Top 10 + otros
  const TOP_N = 10;
  const topItems = combinedArray.slice(0, TOP_N);
  const others = combinedArray.slice(TOP_N);
  if (others.length > 0) {
    const sumOthers = others.reduce(
      (acc, curr) => {
        acc.value += curr.value;
        return acc;
      },
      { id: "OTRAS", label: "OTRAS", value: 0 }
    );
    topItems.push(sumOthers);
  }

  // Generar colores para cada segmento
  const pieColors = [
    colors.primary,
    colors.secondary,
    colors.accent,
    "#60a5fa", // azul más claro
    "#818cf8", // púrpura más claro
    "#34d399", // verde más claro
    "#3b82f6", // azul medio
    "#6366f1", // púrpura medio
    "#10b981", // verde medio
    "#2563eb", // azul oscuro
  ];

  const theme = {
    background: colors.cardBg,
    axis: {
      ticks: {
        text: {
          fill: colors.text,
          fontSize: 12,
        },
      },
    },
    legends: {
      text: {
        fill: colors.text,
        fontSize: 12,
      },
    },
    tooltip: {
      container: {
        background: colors.cardBg,
        color: colors.text,
        fontSize: 12,
        borderRadius: 8,
        boxShadow: colors.shadow,
        border: `1px solid ${colors.border}`,
      },
    },
    labels: {
      text: {
        fill: colors.cardBg,
        fontSize: 12,
        fontWeight: 500,
      },
    },
  };

  return (
    <div style={{ height: "400px", background: colors.cardBg }}>
      <ResponsivePie
        data={topItems}
        margin={{ top: 40, right: 80, bottom: 80, left: 80 }}
        innerRadius={0.6}
        padAngle={0.5}
        cornerRadius={4}
        activeOuterRadiusOffset={8}
        colors={pieColors}
        theme={theme}
        borderWidth={1}
        borderColor={colors.cardBg}
        enableArcLinkLabels={true}
        arcLinkLabelsSkipAngle={10}
        arcLinkLabelsTextColor={colors.text}
        arcLinkLabelsThickness={2}
        arcLinkLabelsColor={colors.border}
        arcLabelsSkipAngle={10}
        arcLabelsTextColor={colors.cardBg}
        defs={[
          {
            id: "dots",
            type: "patternDots",
            background: "inherit",
            color: colors.border,
            size: 4,
            padding: 2,
            stagger: true,
          },
          {
            id: "lines",
            type: "patternLines",
            background: "inherit",
            color: colors.border,
            rotation: -45,
            lineWidth: 3,
            spacing: 8,
          },
        ]}
        legends={[
          {
            anchor: "bottom",
            direction: "row",
            justify: false,
            translateX: 0,
            translateY: 56,
            itemsSpacing: 0,
            itemWidth: 100,
            itemHeight: 18,
            itemTextColor: colors.text,
            itemDirection: "left-to-right",
            itemOpacity: 1,
            symbolSize: 18,
            symbolShape: "circle",
            effects: [
              {
                on: "hover",
                style: {
                  itemTextColor: colors.primary,
                  itemBackground: colors.hover,
                },
              },
            ],
          },
        ]}
        motionConfig={{
          mass: 1,
          tension: 170,
          friction: 26,
          clamp: false,
          precision: 0.01,
          velocity: 0,
        }}
        transitionMode="startAngle"
        role="application"
        ariaLabel="Gráfico circular de vehículos por ubicación"
        onClick={(data) => {
          if (onItemSelect) onItemSelect(data.id);
        }}
      />
    </div>
  );
};

export default VehicleLocationsPieChart;
